import * as React from "react";
import { lang } from "../../lang";
import { store } from "../../store";
import { ALERT_TYPE } from "../../HelperSrc";
import { Button } from "../../components/atoms/Button";
import { Title } from "../../components/atoms/Text";
import { logout } from "../../actions/logout";

class PopupAlert extends React.Component<{
    onClose?: () => void;
    big?: boolean;
}> {
    public buttonRef = React.createRef<HTMLButtonElement>();
    public componentDidMount(): void {
        setTimeout(() => this.buttonRef.current?.focus(), 50);
    }
    public render(): React.ReactElement {
        const { onClose } = this.props;
        const renderTitle = () => {
            if (store.alert.type === ALERT_TYPE.ERROR) return lang.error;
            else if (store.alert.type === ALERT_TYPE.ALERT) return lang.alert;
            else if (store.alert.type === ALERT_TYPE.SUCCESS) return lang.success;
        };
        return (
            <>
                <div className="popup-alert-grayback" onClick={onClose} />
                <div className="popup-alert-box">
                    <Title className="text_center">{renderTitle()}</Title>
                    <div className="popup_alert_text" data-at_id="popup_alert">
                        {store.alert.message}
                    </div>
                    <Button
                        onBlur={() => {
                            this.buttonRef.current?.focus();
                        }}
                        innerRef={this.buttonRef}
                        title="OK"
                        style={{ width: "100%" }}
                        data-at_id="popup_alert_ok"
                        onClick={() => {
                            if (store.alert.mode === "logout") {
                                logout();
                            }

                            store.alert = {
                                type: ALERT_TYPE.ALERT,
                                message: "",
                                mode: ""
                            };
                        }}
                    />
                </div>
            </>
        );
    }
}

export { PopupAlert };
